import "core-js/modules/es.array.concat.js";
/**
 * Convert our direction and align props to a Popper.js placement option.
 * @see {@link Placement}
 */
export var getPopperPlacement = function getPopperPlacement(direction, align) {
  var directionFinal;
  switch (direction) {
    case 'above':
      directionFinal = 'top';
      break;
    case 'below':
      directionFinal = 'bottom';
      break;
    default:
      directionFinal = direction;
      break;
  }
  var alignFinal = align === 'center' ? '' : align;
  var joiner = alignFinal ? '-' : '';
  return "".concat(directionFinal).concat(joiner).concat(alignFinal);
};